module.exports = __webpack_public_path__ + "static/media/HistoryImg .063d0e16.jpg";